import React from 'react';
import { useHistory } from 'react-router-dom';
import {
  ButtonBack,
  ContainerProcedure,
  SubContainer
} from '../../../certificates-constancies/type1/info/components';
import { BtnRequest } from '../../IssuanceUniversityCard/info/components/styled';
import { ProcedureInfoComponent } from './components/ProcedureInfoComponent';
import Spinner from '@/presentation/components/Spinner';
import Modal from '../../../../components/Modal/Modal';
import NotAvailable from '@/presentation/modules/procedures/components/Modals/NotAvailable';
import MyModal from '@/presentation/modules/procedures/components/Modals/MyModal';
import ProcedureHeader from '@/presentation/modules/procedures/components/ContainerProcedure/Header';

interface LateExamInfoProps {
  onBackButton: () => void;
  handleExistRequest: () => void;
  procedureSelectedInfoLateExamen: any;
  notAvailableModal: {
    showNotAvailableModal: boolean;
    setShowNotAvailableModal: (error: boolean) => void;
  };
  NotEnrollmentModal: {
    showNotEnrollmentModal: boolean;
    setShowNotEnrollmentModal: (error: boolean) => void;
  };
}

const LateExamInfoView: React.FC<LateExamInfoProps> = ({
  onBackButton,
  handleExistRequest,
  procedureSelectedInfoLateExamen,
  notAvailableModal,
  NotEnrollmentModal
}) => {
  const { setShowNotAvailableModal, showNotAvailableModal } = notAvailableModal;
  const { showNotEnrollmentModal, setShowNotEnrollmentModal } =
    NotEnrollmentModal;
  const history = useHistory();
  const routeTo = () => {
    history.push('/tramites');
  };
  return (
    <div data-testid="cmp-lateexameninfoview">
      <ContainerProcedure>
        <SubContainer>
          <ButtonBack onClick={onBackButton} />
          <ProcedureHeader name="Examen de Rezagados" />
        </SubContainer>
        <SubContainer>
          {!procedureSelectedInfoLateExamen && <Spinner />}
          {procedureSelectedInfoLateExamen && (
            <>
              <ProcedureHeader
                amount={procedureSelectedInfoLateExamen?.amount}
                duration={procedureSelectedInfoLateExamen?.duration}
                date={procedureSelectedInfoLateExamen?.endDate}
                star="*"
                paddingData={12}
                paddingBottomData={16}
              />
              <ProcedureInfoComponent />
              <BtnRequest
                data-testid="cmp-btnrequest-change"
                onClick={handleExistRequest}
              >
                <p>Empezar solicitud</p>
              </BtnRequest>
            </>
          )}
        </SubContainer>
      </ContainerProcedure>
      <Modal
        show={showNotAvailableModal}
        handleClose={() => setShowNotAvailableModal(false)}
      >
        <NotAvailable handleClick={routeTo} />
      </Modal>
      <MyModal
        show={showNotEnrollmentModal}
        data={{
          title: 'Tienes que estar matriculado en el ciclo vigente'
        }}
        handlerClick={routeTo}
        handlerClose={() => {
          setShowNotEnrollmentModal(false);
        }}
      />
    </div>
  );
};
export default LateExamInfoView;
